export const separatedStyles = {
	separator: {
		mx: 0.5
	},
	cutRow: {
		overflow: 'hidden',
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis'
	}
};
